// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"d65d6be9","401":"073e978d","479":"0b63adf7","488":"56d0c515","491":"39ac9805","492":"3560b583","506":"f9f5263f","771":"8a4b9e9e","811":"6f448a99","899":"713c53c0","916":"fc2b4c95","988":"9a10a7e5"}[chunkId] + ".chunk.js";
};